import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { MdArrowForward } from 'react-icons/md';
import axios from '../api';


const Login = () => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState(1);
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const [error, setError] = useState('');

  React.useEffect(() => {
    document.title = 'ورود | آگاه‌جو';
  }, []);

  const requestOtp = async () => {
    setError('');
    if (!recaptchaToken) {
      setError('لطفاً تأیید کنید که ربات نیستید.');
      return;
    }
    try {
      await axios.post('/auth/request-otp/', { phone, recaptcha: recaptchaToken });
      setStep(2);
    } catch (err) {
      if (err.response) {
        if (err.response.status === 404) {
          setError('سرویس مورد نظر یافت نشد.');
        } else if (err.response.status === 401) {
          setError('دسترسی غیرمجاز. لطفاً دوباره وارد شوید.');
        } else if (err.response.data && err.response.data.error) {
          setError(err.response.data.error);
        } else {
          setError('خطا در دریافت کد تأیید. لطفاً بعداً تلاش کنید.');
        }
      } else {
        setError('ارتباط با سرور برقرار نشد.');
      }
    }
  };

  const verifyOtp = async () => {
    setError('');
    try {
      const res = await axios.post('/auth/verify-otp/', { phone, otp });
      if (res.data.token) {
        localStorage.setItem('token', res.data.token);
      }
      if (res.data.message === 'تایید شد.') {
        try {
          const profileRes = await axios.get('/profile/');
          // Handle case where user info is nested under 'user' key
          let userObj = profileRes.data;
          if (userObj.user && typeof userObj.user === 'object') {
            userObj = userObj.user;
          }
          console.log('User object:', userObj);
          const { id, username, email } = userObj;
          localStorage.setItem('user', JSON.stringify({ id, username, email }));
        } catch {
          localStorage.setItem('user', JSON.stringify({ username: phone }));
          console.log('User object not saved:');
        }
        window.location.href = '/';
      } else if (res.data.error) {
        setError(res.data.error);
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 404) {
          setError('سرویس مورد نظر یافت نشد.');
        } else if (err.response.status === 401) {
          setError('توکن معتبر نیست. لطفاً دوباره وارد شوید.');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        } else if (err.response.data && err.response.data.error) {
          setError(err.response.data.error);
        } else {
          setError('کد تایید اشتباه است یا منقضی شده.');
        }
      } else {
        setError('ارتباط با سرور برقرار نشد.');
      }
    }
  };

  return (
    <Box sx={{ direction: 'rtl', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', px: 2, py: 8 }}>
      <Paper elevation={3} sx={{ borderRadius: 3, p: 4, width: '94%', maxWidth: 400, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: -1 }}>
          <IconButton onClick={() => navigate(-1)} size="small" sx={{ color: '#64748b', '&:hover': { color: '#1976d2' } }}>
            <MdArrowForward size={22} />
          </IconButton>
          <Typography variant="body2" sx={{ color: '#64748b', mr: 0.5 }}>بازگشت</Typography>
        </Box>


        {step === 1 ? (
          <>
            <TextField value={phone} onChange={e => setPhone(e.target.value)} label="شماره تلفن" variant="outlined" size="medium" sx={{ mb: 3 }} fullWidth inputProps={{ style: { textAlign: 'right' } }} />
            <ReCAPTCHA
              sitekey="6Lc0GpYrAAAAAIdp7YGWZ8bCiwXnoO5EBx1h1eYF"
              onChange={token => setRecaptchaToken(token)}
              style={{ marginBottom: 16, alignSelf: 'center' }}
            />
            {error && <Typography color="error" align="center" sx={{ mb: 1 }}>{error}</Typography>}
            <Button onClick={requestOtp} variant="contained" color="success" sx={{ py: 1.5, fontWeight: 'bold' }} fullWidth>دریافت کد تایید</Button>
          </>
        ) : (
          <>
            <TextField value={otp} onChange={e => setOtp(e.target.value)} label="کد تایید" variant="outlined" size="medium" sx={{ mb: 3 }} fullWidth inputProps={{ style: { textAlign: 'right' } }} />
            {error && <Typography color="error" align="center" sx={{ mb: 1 }}>{error}</Typography>}
            <Button onClick={verifyOtp} variant="contained" color="primary" sx={{ py: 1.5, fontWeight: 'bold' }} fullWidth>ورود</Button>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default Login;
